const CollectiveFilter = Object.freeze({
  section: 'sections',
  course: 'courses',
  subcommunity: 'subcommunities',
});

export default CollectiveFilter;
